/** import the scss main file for compiling **/
import styles from '../scss/style.scss'; // eslint-disable-line no-unused-vars

import {Application} from 'argo-js/src/base';
import * as userComp from './user';
import * as components from './components';
import Const from 'argo-js/src/base/Const';
import {Dialog} from './components/Dialog';
import {Response} from 'argo-js/src/data';
import {NetworkError, TimeoutError, UnauthorizedError, ForbiddenError, ServiceUnavailableError, BadGatewayError,
  GatewayTimeoutError} from 'argo-js/src/data/error';
import {Toast} from './ui/Toast';
import {Utils} from 'argo-js/src/common/Utils';

let i18nDict = window[Const.I18N_VARNAME] = window.i18n;
const REPORT_ALL_ERRORS = true;
const helpMailTpl = require('./templates/globalErrorHelpMail.hbs');

// initialize i18n for jquery validate
if (i18nDict.validationMessage) {

  // add jquery validate specific formatter wrapper
  if (i18nDict.validationMessage._format) {
    for (let vkey in i18nDict.validationMessage._format) {
      i18nDict.validationMessage[vkey] = $.validator.format(i18nDict.validationMessage._format[vkey]);
    }
  }
  $.extend($.validator.messages, i18nDict.validationMessage);
}

let referrerUrl = Utils.getQueryParams().referrer;
if(!referrerUrl) {
  let documentRefererUrl = document.referrer || '/';
  documentRefererUrl = documentRefererUrl.replace(window.location.origin, '');

  if(documentRefererUrl.startsWith('/auth')) {
    referrerUrl = sessionStorage.getItem('returnUrl') || '/';
  } else {
    referrerUrl = documentRefererUrl;
  }
}

if(referrerUrl.search(/login.html/i) > -1) {
  referrerUrl = referrerUrl.replace('login', 'index');
}

sessionStorage.setItem('returnUrl',  referrerUrl);

let app = new Application({
  config: {
    homeUrl: (user) => {
      if (!user.isAuthorized()) {
        return '/auth/login.html';
      } else {
        return referrerUrl;
      }
    },
    referrerUrl: referrerUrl
  },
  components: {
    user: userComp,
    components: components
  },
  methods: {
    handleGlobalError: function(err) {
      return [NetworkError, TimeoutError, ForbiddenError, ServiceUnavailableError, /*UnauthorizedError,*/
        BadGatewayError, GatewayTimeoutError]
        .some((ErrClass) => {
          if (ErrClass.predicate(err)) {
            let name = ErrClass.name;
            this.invoke('displayError', [err, name, REPORT_ALL_ERRORS]);
            return true;
          }
          return false;
        });
    },

    unexpectedError: function (err) {
      let name = 'UnexpectedError.api';
      if (err instanceof Error) {
        name = 'UnexpectedError.other';
      }
      //this.invoke("displayError", [err, name, true]);
      this.invoke('displayError', [err, name, false]);
    },

    displayError: function(err, name, reportable='false') {
      let content = this.t(`global${name}.content`).replace(/\{([a-z]+)\}/g, function (find, match) {
        return err[match];
      });
      let title = this.t(`global${name}.title`);
      if (!reportable) {
        Dialog.info(title, content);
        return;
      }

      content += this.t('globalError.sendErrorReport.content');
      Dialog.confirm(title, content, {
        submitLabel: this.t('globalError.sendErrorReport.submitLabel'),
        abortLabel: this.t('globalError.sendErrorReport.abortLabel')
      })
        .then((accept) => {
          if (accept) {

            let requestId = (err.requestid) ? err.requestid : 'N/A';
            let fullError = (err instanceof Error) ? err.stack : JSON.stringify(err, null, 2);
            let fullUserName = (this.user && this.user.get('fullname')) ? this.user.get('fullname') : 'No user logged in.';
            let viewLocation = window.location.href;
            let frontendErrorMessage = content;
            let frontendErrorTitle = title;


            let props = {
              name,
              fullUserName,
              requestId,
              viewLocation,
              frontendErrorTitle,
              frontendErrorMessage,
              error: fullError
            };

            let htmlMail = helpMailTpl(props);
            this.sendMessage('@support', this.t('globalError.sendErrorReport.subject'), htmlMail);
            Toast.success(this.t('globalError.sendErrorReport.success'));
          }
        });
    }
  }
});

Response.Promise().onPossiblyUnhandledRejection((err, promise) => {
  app.invoke('unexpectedError', [err]);
  console.error(err, promise);
});

// global error handler here
Response.interceptError(function(resp) {

  // show login dialog if user lost his session
  if (resp.request.config.handleUnauthorized !== false && app.user.has('fullname')) {
    resp.catch(UnauthorizedError.predicate, function() {
      Dialog.login(app.t('loginModal'),{
        app,
        email: app.user.get('fullname')
      });
      resp.promise.cancel();
    });
  }

  resp.catch(function (err) {
    if (app.invoke('handleGlobalError', [err])) {
      resp.promise.cancel(); // error was handled, stop chain
    }
    else {
      throw err; // propagate error
    }
  });
});

$.validator.addMethod( 'alphanumeric', function( value, element ) {
  return this.optional( element ) || /^[A-Za-z0-9-]+$/.test( value );
}, i18nDict.validationMessage.alphanumeric);

$.validator.addMethod( 'yearmonth', function( value, element ) {
  return this.optional( element ) || /^(20\d{2})\/(0[1-9]|1[0-2])$/.test( value );
}, i18nDict.validationMessage.yearmonth);

$.validator.addMethod( 'extension', function( value, element, param ) {
  param = typeof param === 'string' ? param.replace( /,\s/g, '|' ) : 'png|jpe?g|gif';
  return this.optional( element ) || value.match( new RegExp( '\\.(' + param + ')$', 'i' ) );
}, i18nDict.validationMessage.extension);

$.validator.addMethod( 'argopassword', function( value, element ) {
  return this.optional( element ) || /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,30}$/.test( value );
}, i18nDict['error.PASSWORD_DOES_NOT_MATCH_RULES']);

app.init();